import { format } from "date-fns-tz";
import { buildPickemMakePicksPath } from "pages/PageConfigs";
import { selectTournamentName } from "selectors/Tournament";
import {
  OptionContainer,
  PickemName,
  TimeLeft,
  TournamentLogoContainer,
} from "./styles";
import { TournamentLogo } from "components/Logo/TournamentLogo";
import { selectTourTrigramDisplayForTournamentId } from "selectors/Tour";
import { useAppSelector } from "app/hooks";
import { PlainNavLink } from "styles/elements";

interface Props {
  pickemId: string;
  tournamentId: string;
  name: string;
  closeTime: number;
}

// todo - combine similar code with Upcoming equivalent
export const ActivePickemOption = ({
  pickemId,
  tournamentId,
  name,
  closeTime,
}: Props) => {
  const tourTrigram = useAppSelector((state) =>
    selectTourTrigramDisplayForTournamentId(state, tournamentId)
  );

  const tournamentName = useAppSelector((state) =>
    selectTournamentName(state, tournamentId)
  );

  const closeTimeText =
    "Closes: " + format(new Date(closeTime), "dd/MM/yy HH:mm zzz");

  return (
    <PlainNavLink to={buildPickemMakePicksPath(tournamentId, pickemId)}>
      <OptionContainer>
        <TournamentLogoContainer>
          <TournamentLogo id={tournamentId} />
        </TournamentLogoContainer>
        <PickemName>
          {!!tourTrigram ? `${tourTrigram} ` : ""}
          {tournamentName} - {name}
        </PickemName>
        <TimeLeft>{closeTimeText}</TimeLeft>
      </OptionContainer>
    </PlainNavLink>
  );
};
